import React, { useState } from 'react';
import { Container } from 'react-bootstrap';
import SalesForceTable from '../../../../components/tables/SalesForceTable';

const ASM = () => {
  // Sample data generator
  const generateSampleData = (count = 35) => {
    const states = [
      'Maharashtra', 'Delhi', 'Karnataka', 'Tamil Nadu', 'Gujarat',
      'Rajasthan', 'Uttar Pradesh', 'West Bengal', 'Telangana', 'Punjab',
      'Haryana', 'Kerala', 'Madhya Pradesh', 'Andhra Pradesh', 'Bihar'
    ];
    const names = [
      'Arjun Mehta', 'Kavya Iyer', 'Rohan Das', 'Sana Khan',
      'Kunal Jain', 'Shruti Deshmukh', 'Varun Nambiar', 'Priyanka Roy',
      'Abhishek Pandey', 'Ishita Chatterjee', 'Nikhil Reddy', 'Ananya Pillai',
      'Siddharth Rao', 'Tanvi Malhotra', 'Aditya Kapoor', 'Riya Sinha',
      'Akash Verma', 'Neha Kulkarni', 'Rahul Bhatia', 'Simran Kaur'
    ];
    
    return Array.from({ length: count }, (_, i) => ({
      id: `ASM${String(i + 1).padStart(4, '0')}`,
      name: names[Math.floor(Math.random() * names.length)],
      mobile: `+91 ${Math.floor(Math.random() * 9000000000) + 1000000000}`,
      state: states[Math.floor(Math.random() * states.length)],
      date: new Date(2021 + Math.floor(Math.random() * 4), Math.floor(Math.random() * 12), Math.floor(Math.random() * 28) + 1)
        .toISOString().split('T')[0]
    }));
  };

  // Initialize data with state
  const [salesData, setSalesData] = useState({
    data: generateSampleData(35)
  });

  // Handle data change (add/edit)
  const handleDataChange = (newData) => {
    setSalesData({
      data: newData
    });
  };

  return (
    <Container fluid className="">
      <SalesForceTable
        data={salesData.data}
        salesRole="Area Manager"
        onDataChange={handleDataChange}
      />
    </Container>
  );
};

export default ASM;

